export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_amzSkuNo') || 'SKU',
    field: 'amzSkuNo',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'skuInfo' },
  },
  {
    title: that.$l('table_label_estimatedSales') || '补货基数',
    field: 'estimatedSales',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_estimatedFlipQuantity') || '预计翻单数量',
    field: 'estimatedFlipQuantity',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_confirmedSales') || '确认补货基数',
    field: 'confirmedSales',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_actualFlipQuantity') || '实际翻单数量',
    field: 'actualFlipQuantity',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_earliestDeliveryDate') || '期望最早交货日期',
    field: 'earliestDeliveryDate',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
  },
]
